import React, { createContext, useState } from "react";

export const MenuPathContext = createContext();

export const MenuPathProvider = ({ children }) => {
  const [menuPath, setMenuPath] = useState([]);

  return (
    <MenuPathContext.Provider value={{ menuPath, setMenuPath }}>
      {children}
    </MenuPathContext.Provider>
  );
};
